import React, {ComponentType, useMemo} from "react";
import CustomerDetailsBasicEditor from "./index";
import {IProps, IContainerProps, IServices, IHandlers} from './types';

/**
* Gets the interface types as array of strings so we don't need hand code them each time (and reduces chance for mistakes).
*/
import {keys} from 'ts-transformer-keys';
import {hot} from "react-hot-loader";
import {ThemeProvider} from "@material-ui/core/styles";
import ReactUtilsService from "app/services/reactUtils.service";
import AdminService from 'external-services/diary-admin-service/admin.service';

const NS = 'CustomerDetailsBasicEditorContainer';

const propsKeys: string[] = keys<IProps>();
const containerPropsKeys: string[] = keys<IContainerProps>();
const handlersKeys: string[] = keys<IHandlers>();
const servicesKeys: string[] = keys<IServices>();


const ThemeWrap = function(all: IProps & IContainerProps & IHandlers & IServices) {

  /**
    * Sorts 'all' into IServices, IProps and IContainerProps
    */
  const {}: IServices = ReactUtilsService.getObjectByKeys(all, servicesKeys) as IServices;
  const props: IProps = ReactUtilsService.getObjectByKeys(all, propsKeys) as IProps;
  const {firstName, phone, handleUpdate}: IContainerProps = ReactUtilsService.getObjectByKeys(all, containerPropsKeys) as IContainerProps;
  props.country = useMemo(() => AdminService.getVenue().country, []);
  /**
   * Handlers used to modify app state (via a service) from within the module's container.
   * Similar to redux mapDispatchToProps.
   */
  const handlers: IHandlers = {
    handleFirstNameChange: (value: string) => {
      handleUpdate(value, phone);
    },
    handlePhoneChange: (value: string) => {
      handleUpdate(firstName, value);
    },
  }


  return ReactUtilsService.containerWrap(
    <CustomerDetailsBasicEditor {...props} {...handlers} />
  );
}

/**
 * Returns properties needed for rendering react2angular
 */
export const R2ACustomerDetailsBasicEditor: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(ThemeWrap) as ComponentType<unknown>,
  [...containerPropsKeys] as never[],
  servicesKeys
];
